import { userProfileApi } from "@/lib/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { UpdateSystemPreferencesRequest } from "@/gen/api/backend/model"

const useUpdatePreferences = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateSystemPreferencesRequest) => {
      const response = await userProfileApi.updateSystemPreferences(data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["system-preferences"] })
    },
  })
}

export default useUpdatePreferences
